export default __webpack_public_path__ + "static/exponential-knowledge-time-d42de9aed2f61c4cd863d30444fd5071.png";